module.exports = "/assets/data/a2d5588da9f80641facaa3bd13ef081d-BS2.data.json";